import moment from "moment"

const videoCallData = (state = [], action) => {
    switch(action.type){
        case 'VIDEO_CALL_LIST_RECEIVE_DATA':
            state = action.payload;  
            localStorage.setItem('my_video_calls_data',JSON.stringify(state))
            return state;  
        case 'VIDEO_CALL_LIST_SEARCH':
            const text = action.payload;
            const allData = JSON.parse(localStorage.getItem('my_video_calls_data'));
            const filterData = allData.filter(item => {      
                let itemData = `${item.patient_id.first_name.toUpperCase()+moment(item.meeting_date).format('M/D/Y')}`; 
                if(item.patient_id.last_name !== undefined) {
                    itemData+= `${item.patient_id.last_name.toUpperCase()}`;
                }

                let textData = text.toUpperCase(); 
                return itemData.indexOf(textData) > -1;    
            });  
            state = filterData;  
            return state;  
  
        default:
              return state;

    }
};

export default videoCallData;